import { MenuDataLocale } from "../menudata/types/MenuDataLocale";

export const getVenueServiceFeeText = (menuDataLocale: MenuDataLocale, venueServiceFeeFactor: number) => {
    if (menuDataLocale.locale === "en-GB" || menuDataLocale.locale === "en-US") {
        return `Venue service fee ${menuDataLocale.formatPercent(venueServiceFeeFactor)}`;
    }

    return `Convenience fee ${menuDataLocale.formatPercent(venueServiceFeeFactor)}`;
};
